import { ApexOptions } from 'apexcharts';

interface ChartData {
  series: number[];
  labels: string[];
}

export const miceActivityDonutChartOptions = (chartData: ChartData) => {
  const totalSum = chartData.series.reduce((acc, val) => acc + val, 0);
  const baseColors = [
    '#3366FF',
    '#299EFF',
    '#29E8FF',
    '#29FFEF',
    '#f2fa14',
    '#FFF529',
    '#FFE529',
    '#FFCE29',
    '#FFA429',
    '#FF8429',
    '#4929FF',
    '#293CFF',
  ];
  const dynamicColors = baseColors.map((color, index) => {
    const value = chartData.series[index];
    return value > 0 ? color : 'rgba(211, 211, 211, 0.4)';
  });
  const legendTextColors = baseColors.map((_, index) => {
    const value = chartData.series[index];
    return value > 0 ? '#000000' : 'rgba(211, 211, 211, 0.7)';
  });
  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    colors: dynamicColors,
    series: chartData.series || [],
    labels: chartData.labels || [],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    legend: {
      fontSize: '10px',
      position: 'right',
      offsetY: 35,
      formatter: (seriesName: string, opts: any) => {
        return `<span style="color: ${legendTextColors[opts.seriesIndex]} !important;">${seriesName}</span>`;
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      markers: {
        size: 8,
      },
      onItemClick: {
        toggleDataSeries: false,
      },
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
    },
    dataLabels: {
      enabled: true,
      formatter: (_val: any, opts: any) => {
        const seriesIndex = opts.seriesIndex;

        if (seriesIndex < 0 || seriesIndex >= chartData.series.length) {
          return '';
        }

        const count = chartData.series[seriesIndex];
        const timePeriod = chartData.labels[seriesIndex];

        if (typeof count === 'number' && timePeriod) {
          const percentage = (count / totalSum) * 100;
          if (percentage >= 5) {
            return [String(timePeriod), `${count} mice`];
          }
        }

        return '';
      },
      style: {
        colors: ['#000', '#000', '#000', '#000', '#000'],
        fontSize: '12px',
        fontWeight: 'bold',
      },
      dropShadow: {
        enabled: true,
        color: '#111',
        top: 0,
        left: 0,
        blur: 3,
        opacity: 0.7,
      },
    },
    fill: {
      type: 'gradient',
    },
    responsive: [
      {
        breakpoint: 636,
        options: {
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
        },
      },
    ],
  };

  return chartOptions;
};
